// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7522 ? "3beab2b6" : chunkId) + "." + {"7522":"ad376f99badf048f","8258":"5a0175ffb3937680"}[chunkId] + ".js";
};